import RenderQuality from "../../render-quality";

async function getKnownGPUS() {
    return KNOWN_GPUS;
}

export default getKnownGPUS;
export { getKnownGPUS };

const KNOWN_GPUS = Object.freeze({
    "GeForce GTX 10": {
        allowedQuality: RenderQuality.HIGH
    },
    "GeForce RTX 20": {
        allowedQuality: RenderQuality.HIGH
    },
    "GeForce RTX 30": {
        allowedQuality: RenderQuality.HIGH
    }
});